export enum EnumGroupHomeTag {
    /**
     * 新闻资讯
     */
    xinwzx = "1080412644754591744",
    /**
     * 通知通告
     */
    tongztg = "1080412677361111040",
    /**
     * 活动集锦
     */
    huodjj = "1080412761108779008",
    /**
    * 员工活动
    */
    yuanghd = "1080412810442182656",

    /**
    * 合作案例
    */
    hezal = "1080412960564711424",
    /**
     * 招聘岗位
     */
    zhaopgw = "1080782499938103296"
}